/* eslint-env browser */
import * as React from 'react'

const ReactDOM = require('react-dom')
const SignupForm = require('../../client/clientjs/components/login-signup/SignupForm')

require('../../container/client')

const DomHelper = require('../../client/clientjs/dom-helper')
const ModalsHelper = require('../../client/clientjs/utils/modals')

// inline registration form
const inlineRegistrationFormHolder = DomHelper.query('#react-render-inline-registration-form')
if (inlineRegistrationFormHolder) {
  ReactDOM.hydrate(
    <SignupForm isInline locale={window.initialState.locale.identifierShort} />,
    inlineRegistrationFormHolder
  )
}

const carousels = {}

DomHelper.onDocumentReady(() => {
  const carouselsElt = DomHelper.queryAll('[data-landing-carousel]')
  carouselsElt.forEach(elt => {
    const carouselId = DomHelper.data(elt, 'landing-carousel')
    if (carousels[carouselId]) {
      clearInterval(carousels[carouselId].intervalId)
      carousels[carouselId] = null
    }
    carousels[carouselId] = {
      currentIndex: 0,
      maxIndex: DomHelper.queryAll(elt, '[data-landing-carousel-item]').length - 1,
    }
    carousels[carouselId].intervalId = setInterval(() => {
      let idx = carousels[carouselId].currentIndex
      if (idx >= carousels[carouselId].maxIndex) {
        idx = 0
      } else {
        idx += 1
      }
      carousels[carouselId].currentIndex = idx
      const items = DomHelper.queryAll(elt, '[data-landing-carousel-item]')
      items.forEach((item, itemIdx) => {
        if (itemIdx === idx) {
          DomHelper.removeClass(item, 'zero-opacity-animated')
        } else {
          DomHelper.addClass(item, 'zero-opacity-animated')
        }
      })

      const cardItems = DomHelper.queryAll(`[data-landing-target-carousel=${carouselId}]`)
      cardItems.forEach((item, itemIdx) => {
        if (itemIdx === idx) {
          if (DomHelper.hasClass(item, 'small-shadow')) {
            DomHelper.addClass(item, 'medium-shadow')
          } else {
            DomHelper.addClass(item, 'medium-shadow-left')
          }
          DomHelper.addClass(item, 'selected')
        } else {
          DomHelper.removeClass(item, 'medium-shadow')
          DomHelper.removeClass(item, 'medium-shadow-left')
          DomHelper.removeClass(item, 'selected')
        }
      })
    }, 4000)
  })

  const carouselActivators = DomHelper.queryAll('[data-landing-carousel-select-index]')
  carouselActivators.forEach(carouselActivator => {
    carouselActivator.onmouseover = () => {
      const targetCarouselId = DomHelper.data(carouselActivator, 'landing-target-carousel')

      carouselActivators.forEach(a => {
        if (a !== carouselActivator) {
          DomHelper.removeClass(a, 'medium-shadow')
          DomHelper.removeClass(a, 'medium-shadow-left')
          DomHelper.removeClass(a, 'selected')
        }
      })
      if (DomHelper.hasClass(carouselActivator, 'small-shadow')) {
        DomHelper.addClass(carouselActivator, 'medium-shadow')
      } else {
        DomHelper.addClass(carouselActivator, 'medium-shadow-left')
      }
      DomHelper.addClass(carouselActivator, 'selected')

      const carousel = DomHelper.query(`[data-landing-carousel=${targetCarouselId}]`)
      const targetIdx = parseInt(DomHelper.data(carouselActivator, 'landing-carousel-select-index'), 10)
      carousels[targetCarouselId].currentIndex = targetIdx
      const items = DomHelper.queryAll(carousel, '[data-landing-carousel-item]')
      items.forEach((item, itemIdx) => {
        if (itemIdx === targetIdx) {
          DomHelper.removeClass(item, 'zero-opacity-animated')
        } else {
          DomHelper.addClass(item, 'zero-opacity-animated')
        }
      })
      clearInterval(carousels[targetCarouselId].intervalId)
    }
  })

  if (window.location && window.location.search.includes('target=openLogin')) {
    ModalsHelper.open('#modal-login')
  }
  if (window.location && window.location.search.includes('target=openSignup')) {
    ModalsHelper.open('#modal-signup')
  }
})

if (module.hot) {
  module.hot.accept()
}
